// extracted by mini-css-extract-plugin
export default {"edit-svg-wrapper":"withBrandingColor_edit-svg-wrapper__k+uOP","edit-color":"withBrandingColor_edit-color__um1Pz","delete-color":"withBrandingColor_delete-color__NJoUN"};